var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.5C18.0751 23.5 23 18.5751 23 12.5C23 6.42487 18.0751 1.5 12 1.5C5.92487 1.5 1 6.42487 1 12.5C1 18.5751 5.92487 23.5 12 23.5ZM7.3767 11.6157L8.6257 11.2058L8.91173 12.1115L7.66273 12.512L8.45408 13.5989L7.66273 14.1805L6.86184 13.084L6.08956 14.1328L5.31728 13.5512L6.11816 12.512L4.8501 12.0734L5.1552 11.1676L6.40419 11.6157V10.3H7.3767V11.6157ZM12.5483 11.6157L13.7973 11.2058L14.0834 12.1115L12.8344 12.512L13.6257 13.5989L12.8344 14.1805L12.0335 13.084L11.2612 14.1328L10.4889 13.5512L11.2898 12.512L10.0217 12.0734L10.3268 11.1676L11.5758 11.6157V10.3H12.5483V11.6157ZM18.969 11.2058L17.72 11.6157V10.3H16.7475V11.6157L15.4985 11.1676L15.1934 12.0734L16.4614 12.512L15.6605 13.5512L16.4328 14.1328L17.2051 13.084L18.006 14.1805L18.7973 13.5989L18.006 12.512L19.255 12.1115L18.969 11.2058Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialpassword);
export default __webpack_public_path__ + "static/media/Social password.4d8e6b7eba9499c754d5e9543625c13b.svg";
export { ForwardRef as ReactComponent };